<section class="banner" id="banner">
    <!-- <picture> -->
    <!-- <source media="(max-width: 480px)" srcset="../../../assets/home/banner-principal-480px.svg"> -->
    <img src="../../../assets/home/banner-principal.png" alt="Banner do e-commerce Toobook">
    <!-- </picture> -->
</section>

<section class="voucher" id="voucher">
    <img class="background-image" src="../../../assets/home/envelope.png" alt="Envelope aberto">
    <p class="txt txt_voucher">Insira o voucher de acesso que a escola forneceu.</p>

    <form [formGroup]="formVoucher">
        <div class="input-btn">
            <svg viewBox="25 25 50 50" *ngIf="loading_btn">
                    <circle r="20" cy="50" cx="50"></circle>
                  </svg>
            <input name="voucher" placeholder="Voucher" formControlName="voucher">
            <button (click)="acessar()">Acessar
            </button>
        </div>
        <div class="error">
            <p id="error_message" *ngIf="this.formVoucher.get('voucher')?.hasError('required') && this.formVoucher.get('voucher')?.touched">Por favor, digite um voucher.</p>
        </div>
    </form>
</section>

<section class="como_funciona" id="como_funciona">
    <picture>
        <source media="(max-width: 480px)" srcset="../../../assets/home/composition-480px.svg">
        <img src="../../../assets/home/composition.svg" alt="Composição de fotos">
    </picture>

    <article>
        <h2>Como funciona?</h2>
        <p class="txt txt_como_funciona">
            A TooBook oferece uma solução acessível, eficiente e simples para nossas Escolas Parceiras. Agora, os pais ou responsáveis podem adquirir a lista completa do material didático por meio de nossa loja virtual exclusiva. Isso proporciona conforto, facilidade
            e condições muito atrativas para a compra. Com a TooBook, tudo o que você precisa está disponível em um único lugar!
        </p>
    </article>
</section>

<section class="passo_a_passo">
    <h2>Adquira seu material didático em 4 passos simples:</h2>

    <article class="container_cards">
        <div class="card">
            <img src="../../../assets/home/icone_cadeado.svg" alt="Icone de um cadeado">
            <p class="card_numero">1</p>
            <p class="card_titulo">Como Funciona</p>
            <p class="card_descricao">Acesse o site <a href="www.toobok.cpb.com.br">toobook.com.br</a> e insira a chave de acesso fornecida pela escola.</p>
        </div>
        <div class="card">
            <img src="../../../assets/home/icone_recrutamento.svg" alt="Icone de um cadeado">
            <p class="card_numero">2</p>
            <p class="card_titulo">Escolha seus materiais</p>
            <p class="card_descricao">Preencha o nome do aluno, selecione o ano ou série e adicione os produtos desejados ao carrinho.</p>
        </div>
        <div class="card">
            <img src="../../../assets/home/icone_carrinho.svg" alt="Icone de um cadeado">
            <p class="card_numero">3</p>
            <p class="card_titulo">Acesse o carrinho e insira seus dados</p>
            <p class="card_descricao">Complete as informações pessoais e de pagamento para prosseguir com a compra.</p>
        </div>
        <div class="card">
            <img src="../../../assets/home/icone-deposito.svg" alt="Icone de um cadeado">
            <p class="card_numero">4</p>
            <p class="card_titulo">Finalize a compra e aguarde o material</p>
            <p class="card_descricao">Revise sua lista e finalize a compra.</p>
        </div>
    </article>

    <!-- <p class="txt_parabens">Parabéns! Em breve, você receberá seu material didático! Aproveite todos os recursos e conteúdos preparados especialmente para você. O TooBook está aqui para tornar sua experiência educacional ainda mais completa e acessível.</p> -->
</section>

<section class="toobook" id="toobook">
    <h2>Conheça a TooBook</h2>
    <p>A TooBook é o e-commerce do Sistema de Ensino Interativo da CPB educacional. Uma plataforma prática e segura para a compra de materiais didáticos, uma solução personalizada para atender às necessidades dos pais e alunos de adquirir o material sem
        precisar sair de casa. <br> Assim, a escola pode se concentrar no que realmente importa: seus alunos.</p>
</section>

<section class="diferencial" id="contato">
    <article class="formulario">

        <div class="forma">
            <h2>Quero o TooBook em minha escola</h2>
        </div>
        <form [formGroup]="formEscola">
            <div class="input-error">
                <input type="text" placeholder="Nome" formControlName="nome">
                <p *ngIf="formEscola.get('nome')?.invalid && (formEscola.get('nome')?.dirty || formEscola.get('nome')?.touched)">O campo é obrigatório.</p>
            </div>
            <div class="input-error">
                <input type="email" placeholder="E-mail" formControlName="email">
                <p *ngIf="formEscola.get('email')?.invalid && (formEscola.get('email')?.dirty || formEscola.get('email')?.touched)">O campo é obrigatório.</p>
            </div>
            <div class="input-error">
                <input type="text" placeholder="WhatsApp" formControlName="whatsapp" mask="(00) 00000-0000">
                <p *ngIf="formEscola.get('whatsapp')?.invalid && (formEscola.get('whatsapp')?.dirty || formEscola.get('whatsapp')?.touched)">O campo é obrigatório.</p>
            </div>
            <div class="input-error">
                <input type="text" placeholder="Cidade" formControlName="cidade">
                <p *ngIf="formEscola.get('cidade')?.invalid && (formEscola.get('cidade')?.dirty || formEscola.get('cidade')?.touched)">O campo é obrigatório.</p>
            </div>
            <div class="input-error">
                <input type="text" placeholder="Nome da Escola" formControlName="nome_escola">
                <p *ngIf="formEscola.get('nome_escola')?.invalid && (formEscola.get('nome_escola')?.dirty || formEscola.get('nome_escola')?.touched)">O campo é obrigatório.</p>
            </div>
            <div class="input-error">
                <select id="tipoEscola" formControlName="tipo_escola">
                <option value="" disabled selected>Tipo de Escola</option>
                <option value="Pública">Pública</option>
                <option value="Particular">Particular</option>
            </select>
                <p *ngIf="formEscola.get('tipo_escola')?.invalid && (formEscola.get('tipo_escola')?.dirty || formEscola.get('tipo_escola')?.touched)">O campo é obrigatório.</p>
            </div>
            <div class="input-error">
                <select formControlName="segmento">
                <option value="" disabled selected>Em qual segmento você atua</option>
                <option value="Educação Infantil">Educação Infantil</option>
                <option value="Ensino Fundamental – Anos Iniciais">Ensino Fundamental – Anos Iniciais</option>
                <option value="Ensino Fundamental – Anos Finais">Ensino Fundamental – Anos Finais</option>
                <option value="Ensino Médio">Ensino Médio</option>
                <option value="Ensindo Superior">Ensindo Superior</option>
                <option value="Gestão Escolar">Gestão Escolar</option>
                <option value="Não Trabalho com Educação">Não Trabalho com Educação</option>
            </select>
                <p *ngIf="formEscola.get('segmento')?.invalid && (formEscola.get('segmento')?.dirty || formEscola.get('segmento')?.touched)">O campo é obrigatório.</p>
            </div>
            <div class="input-error">
                <select formControlName="cargo_escola">
                <option value="" disabled selected>Cargo na Escola</option>
                <option value="Diretor (a)">Diretor (a)</option>
                <option value="Coordenador (a)">Coordenador (a)</option>
                <option value="Professor (a)">Professor (a)</option>
                <option value="Secretária">Secretária</option>
                <option value="Não trabalho em escola">Não trabalho em escola</option>
                <option value="Outro">Outro</option>
            </select>
                <p *ngIf="formEscola.get('cargo_escola')?.invalid && (formEscola.get('cargo_escola')?.dirty || formEscola.get('cargo_escola')?.touched)">O campo é obrigatório.</p>
            </div>
            <div class="input-error">
                <select formControlName="alunos_escola">
                <option value="" disabled selected>Quantos alunos estudam na sua escola</option>
                <option value="Até 150 alunos">Até 150 alunos</option>
                <option value="De 150 a 400 alunos">De 150 a 400 alunos</option>
                <option value="De 400 a 600 alunos">De 400 a 600 alunos</option>
                <option value="De 600 a 1.000 alunos">De 600 a 1.000 alunos</option>
                <option value="Mais de 1.000 alunos">Mais de 1.000 alunos</option>
                <option value="Não trabalho em escola">Não trabalho em escola</option>
            </select>
                <p *ngIf="formEscola.get('alunos_escola')?.invalid && (formEscola.get('alunos_escola')?.dirty || formEscola.get('alunos_escola')?.touched)">O campo é obrigatório.</p>
            </div>
            <textarea name="" id="" cols="30" rows="10" placeholder="Mensagem" formControlName="mensagem"></textarea>

            <div #divRecaptcha id="recaptcha"></div>
            <button (click)="enviaFormularioContato()">Enviar mensagem</button>
        </form>
    </article>


    <article class="diferenciais">

        <h2>Diferenciais</h2>

        <div class="container_card">
            <div class="card_diferencial sob-medida">
                <header>
                    <img src="../../../assets/home/icones-diferenciais/sob_medida.svg" alt="Icone para card - Sob Medida">
                    <p>Sob medida</p>
                </header>
                <section>
                    <p>Um site de compras com acesso restrito à sua comunidade escolar.</p>
                </section>
            </div>
            <div class="card_diferencial entrega">
                <header>
                    <img src="../../../assets/home/icones-diferenciais/entrega.svg" alt="Icone para card - Entrega na sua escola">
                    <p>Entrega na sua escola</p>
                </header>
                <section>
                    <p>Funcionamento em tempo integral, com período previamente negociado.</p>
                </section>
            </div>
            <div class="card_diferencial s-preocupacao">
                <header>
                    <img src="../../../assets/home/icones-diferenciais/s-preocupacao.svg" alt="Icone para card - Sem preocupação">
                    <p>Sem preocupação</p>
                </header>
                <section>
                    <p>Notas fiscais emitidas em nome do cliente final, isentando a escola dessa atividade.</p>
                </section>
            </div>
            <div class="card_diferencial pag-garantido">
                <header>
                    <img src="../../../assets/home/icones-diferenciais/pag-garantido.svg" alt="Icone para card - Pagamento garantido">
                    <p>Pagamento garantido</p>
                </header>
                <section>
                    <p>Risco zero de inadimplência.</p>
                </section>
            </div>
            <div class="card_diferencial estoque">
                <header>
                    <img src="../../../assets/home/icones-diferenciais/estoque.svg" alt="Icone para card - Cuidamos do estoque">
                    <p>Cuidamos do estoque</p>
                </header>
                <section>
                    <p>Sem preocupações com armazenamento, controle ou sobras de materiais.</p>
                </section>
            </div>
            <div class="card_diferencial recurso">
                <header>
                    <img src="../../../assets/home/icones-diferenciais/recurso.svg" alt="Icone para card - Recursos">
                    <p>Recursos</p>
                </header>
                <section>
                    <p>Colabora na provisão de receita para a sua unidade escolar.</p>
                </section>
            </div>
        </div>

        <section class="paragrafo">
            <p>Ao preencher o formulário, você será redirecionado para obter mais informações sobre como implementar o TooBook em sua escola.</p>
            <p>Estamos ansiosos para ajudá-lo a oferecer uma experiência de compra conveniente e atrativa para os pais e responsáveis da sua comunidade escolar.</p>
        </section>
    </article>
</section>

<footer>
    <!-- <div class="endereço">
        <p class="footer_titulo">Endereço</p>
        <p class="footer_descricao">Endereço do local</p>
        <p class="footer_descricao">Rua com e numero</p>
        <p class="footer_descricao">Bairro</p>
        <p class="footer_descricao">Nome da cidade - SP</p>
        <p class="footer_descricao">CEP 18275-080</p>
    </div> -->
    <div class="cnpj">
        <p class="footer_titulo">Contato</p>
        <p class="footer_descricao">
            <a href="https://api.whatsapp.com/send/?phone=551532058892&text&app_absent=0" target="_blank" class="link-whatsapp">
                <svg xmlns="http://www.w3.org/2000/svg" height="22" width="20" viewBox="0 0 448 512">
                    <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                    <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6" style="fill: #2EC3E5;"/>
                </svg>
                <p>
                    WhatsApp: (15) 3205-8892
                </p>
            </a>
        </p>
    </div>
    <div class="redes_sociais">
        <p class="footer_titulo">Nossas redes sociais</p>
        <div class="icones_redes_sociais">
            <a href="https://www.facebook.com/sistemainterativodeensino">
                <img src="../../../assets/home/icone-redes-sociais/facebook.svg" alt="Icone do Facebook">
            </a>
            <a href="https://www.instagram.com/sistemainterativodeensino/">
                <img src="../../../assets/home/icone-redes-sociais/instagram.svg" alt="Icone do Instragram">
            </a>
        </div>
    </div>
    <div class="endereço">
        <p class="footer_titulo">Informações</p>
        <p class="footer_descricao"><a href="/politica-vendas">Política de vendas</a></p>
        <p class="footer_descricao"><a href="/politica-privacidade">Política de privacidade</a></p>
    </div>
    <div class="endereco">
        <div class="bandeiras">
            <ul>
                <li><img alt="visa" title="visa" src="/assets/bandeira-cartao/visa.svg"></li>
                <li><img alt="mastercard" title="mastercard" src="/assets/bandeira-cartao/mastercard.svg"></li>
                <li><img alt="hipercard" title="hipercard" src="/assets/bandeira-cartao/hipercard.svg"></li>
                <li><img alt="elo" title="elo" src="/assets/bandeira-cartao/elo.svg"></li>
                <li><img alt="diners" title="diners" src="/assets/bandeira-cartao/diners.svg"></li>
                <li><img alt="cabal" title="cabal" src="/assets/bandeira-cartao/cabal.svg"></li>
                <li><img alt="amex" title="amex" src="/assets/bandeira-cartao/amex.svg"></li>
                <li><img alt="amex" title="amex" src="/assets/bandeira-cartao/boleto.svg"></li>
            </ul>
        </div>
        <img src="../../../assets/home/abcomm.png" alt="Icone do Abcomm" class="img-rodape-abcomm">
        <img src="../../../assets/home/siteSealImage.png" alt="Icone do SealImage" class="img-rodape-sealimage">
    </div>
</footer>

<div class="copyright">
    <span>&copy; Sistema de Ensino Interativo | CPB Educacional - {{year}}</span>
</div>

<button id="scroll-to-top-btn" (click)="scrollToTop()" *ngIf="showScrollButton">
  <mat-icon class="mat-18">arrow_upward</mat-icon>
</button>